<script>
import PhotoMixing from '../mixins/PhotoMixin.vue'

export default {
  name: "PhotoPreview",
  mixins: [PhotoMixing]
}
</script>
